import React from 'react'
import Container from './Container'

const Hero = (props) => {
  return (
    <section className='hero is-fullheight app-main-hero'>
      <div className='hero-head' />
      <div className='hero-body'>
        <Container>
          {props.children}
        </Container>
      </div>
      <div className='hero-foot' />
    </section>
  )
}

export default Hero



// WEBPACK FOOTER //
// ./src/components/generic/Hero.js